function checkArr(arr) {
  // checks if there are any duplicate values in the array
  if (arr.includes(0) | ([...new Set(arr)].length !== arr.length)) {
    return true;
  }
  return false;
}

export default function sudokuChecker(rowArr, colArr, subgridsArr) {
  const rowErrors = [];
  const colErrors = [];
  const subgridErrors = [];

  rowArr.forEach((row, i) => {
    const hasErr = checkArr(row);
    if (hasErr) {
      rowErrors.push(i);
    }
  });

  colArr.forEach((col, i) => {
    const hasErr = checkArr(col);
    if (hasErr) {
      colErrors.push(i);
    }
  });

  subgridsArr.forEach((subgrid, i) => {
    const hasErr = checkArr(subgrid);
    if (hasErr) {
      subgridErrors.push(i);
    }
  });

  // return object where each key is associated with the list of
  // row, col, or subgrid that has an error
  return {
    row: rowErrors,
    col: colErrors,
    subgrid: subgridErrors,
  };
}
